import { render, staticRenderFns } from "./asidAc.vue?vue&type=template&id=95583ab6&scoped=true"
import script from "./asidAc.vue?vue&type=script&lang=js"
export * from "./asidAc.vue?vue&type=script&lang=js"
import style0 from "./asidAc.vue?vue&type=style&index=0&id=95583ab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95583ab6",
  null
  
)

export default component.exports